import React from "react";

const TermsConditions: React.FC = () => {
  return (
    <div className="bg-[#fffdfb] min-h-screen">
      {/* HEADER */}
      <div className="bg-gradient-to-r from-violet-700 to-purple-500 py-16 px-6">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-5xl font-bold text-white">
            Terms & Conditions
          </h1>

          <p className="text-white/90 text-lg mt-4">
            Last updated: 02/06/2026
          </p>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-5xl mx-auto px-6 py-16">
        <div className="bg-white rounded-[30px] shadow-xl p-10 space-y-10">

          <p className="text-gray-700 text-lg leading-relaxed">
            Welcome to FrendRops. By accessing or using our website,
            mobile application, or services, you agree to comply with
            and be bound by the following Terms & Conditions.
          </p>

          {/* 1 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              1. Acceptance of Terms
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              By using FrendRops services, you confirm that you have
              read, understood, and agreed to these Terms &
              Conditions.
            </p>
          </div>

          {/* 2 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              2. User Accounts
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              You are responsible for maintaining the confidentiality
              of your account credentials and for all activities under
              your account.
            </p>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              FrendRops reserves the right to suspend or terminate
              accounts that violate our policies.
            </p>
          </div>

          {/* 3 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              3. Orders and Payments
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              All orders placed through FrendRops are subject to
              product availability and acceptance.
            </p>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              Payments must be completed using approved payment
              methods available on our platform.
            </p>
          </div>

          {/* 4 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              4. Pricing
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              Prices displayed on FrendRops may change without prior
              notice. We reserve the right to modify product pricing
              at any time.
            </p>
          </div>

          {/* 5 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              5. Delivery
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              Delivery times are estimates and may vary depending on
              location, weather conditions, traffic, festivals, or
              unforeseen circumstances.
            </p>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              FrendRops is not liable for delays caused by third-party
              delivery services or circumstances beyond our control.
            </p>
          </div>

          {/* 6 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              6. Cancellation and Refunds
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              Orders may only be cancelled before dispatch or
              processing. Refunds will be processed according to our
              Refund Policy.
            </p>
          </div>

          {/* 7 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              7. Prohibited Activities
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              Users must not misuse the platform, attempt unauthorized
              access, upload harmful content, distribute malware, or
              engage in fraudulent activities.
            </p>
          </div>

          {/* 8 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              8. Intellectual Property
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              All content, logos, trademarks, graphics, text,
              software, and materials on FrendRops are the property of
              FrendRops and are protected under applicable intellectual
              property laws.
            </p>
          </div>

          {/* 9 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              9. Limitation of Liability
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              FrendRops shall not be held liable for any indirect,
              incidental, special, or consequential damages resulting
              from the use of our services.
            </p>
          </div>

          {/* 10 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              10. Privacy
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              Your use of FrendRops is also governed by our Privacy
              Policy, which explains how we collect, use, and protect
              your information.
            </p>
          </div>

          {/* 11 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              11. Changes to Terms
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              We reserve the right to modify these Terms &
              Conditions at any time without prior notice. Updated
              versions will be posted on this page.
            </p>
          </div>

          {/* 12 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              12. Eligibility
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              By using FrendRops, you confirm that you are at least
              18 years old or have the consent of a parent or legal
              guardian.
            </p>
          </div>

          {/* 13 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              13. Product Availability
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              Product availability may vary based on inventory,
              seasonality, and delivery location. FrendRops reserves
              the right to modify or discontinue products without
              prior notice.
            </p>
          </div>

          {/* 14 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              14. Force Majeure
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              FrendRops shall not be liable for delays or failures
              resulting from events beyond our reasonable control,
              including natural disasters, strikes, internet outages,
              pandemics, transportation disruptions, or government
              actions.
            </p>
          </div>

          {/* 15 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              15. Governing Law
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              These Terms & Conditions shall be governed by and
              construed in accordance with the laws of India. Any
              disputes shall be subject to the exclusive jurisdiction
              of the courts located in Bengaluru, Karnataka.
            </p>
          </div>

          {/* 16 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              16. Contact Us
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              If you have any questions regarding these Terms &
              Conditions, please contact us:
            </p>

            <div className="mt-4 text-gray-700 text-lg space-y-2">
              <p>
                <strong>FrendRops</strong>
              </p>
              <p>Email: frendrops@gmail.com</p>
              <p>Website: https://www.frendrops.in</p>
              <p>Bengaluru, Karnataka, India</p>
            </div>
          </div>

          {/* FOOT NOTE */}
          <div className="bg-violet-50 rounded-2xl p-6 border border-violet-100">
            <p className="text-[#2d1457] text-lg font-medium leading-relaxed">
              By accessing or using FrendRops services, website, or
              mobile application, you acknowledge that you have read,
              understood, and agreed to these Terms & Conditions.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
